import { Series } from "@/types/common";

export const STATS_CONFIG: { [propName: string]: string } = {
  bytes: "memory used",
  max_bytes: "memory limit",
  items: "items",
  eviction_rate: "evictions",
  get_expired_rate: "get expired",
  hit_rate: "overall hit rate",
  get_hit_rate: "get",
  delete_hit_rate: "delete",
  incr_hit_rate: "incr",
  decr_hit_rate: "decr",
  cas_hit_rate: "cas",
  touch_hit_rate: "touch",
  get_fraction: "get",
  set_fraction: "set",
  delete_fraction: "delete",
  incr_fraction: "incr",
  decr_fraction: "decr",
  cas_fraction: "cas",
  touch_fraction: "touch",
  flush_fraction: "flush",
  request_rate: "overall requests",
  get_rate: "get",
  set_rate: "set",
  delete_rate: "delete",
  incr_rate: "incr",
  decr_rate: "decr",
  cas_rate: "cas",
  touch_rate: "touch",
  flush_rate: "flush",
  connections: "active connections",
  connection_rate: "new connection rate",
  bytes_read_rate: "bytes received by server",
  bytes_write_rate: "bytes sent to client",
  // Debug Mode
  prefix_num_keys: "prefix recently touched items",
  prefix_total_size: "prefix recently touched memory",
  prefix_total_hits_rate: "total hits",
  prefix_total_misses_rate: "total misses",
  prefix_total_mutations_rate: "total mutations",
  prefix_hit_rate: "prefix hit rate",
  prefix_requests: "prefix requests",
  compound_num_keys: "total recently touched items",
  compound_total_size: "total recently touched memory",
  compound_total_hits_rate: "total hits",
  compound_total_misses_rate: "total misses",
  compound_total_mutations_rate: "total mutations",
  compound_hit_rate: "total hit rate",
  compound_requests: "total requests",
  prefix_over_compound_total_hits_rate: "total hits fraction",
  prefix_over_compound_total_misses_rate: "total misses fraction",
  prefix_over_compound_total_mutations_rate: "total mutations fraction",
  prefix_over_compound_requests: "request fraction", // corresponding CSS width $label-requests-width
  prefix_over_compound_total_size: "memory fraction", // corresponding CSS width $label-memory-width
  prefix_over_compound_num_keys: "items fraction", // corresponding CSS width $label-items-width
  key_size: "key size",
  key_hit_count: "key hit count per 10 mins",
  key_miss_count: "key miss count per 10 mins",
  key_mutation_count: "key mutation count per 10 mins",
  key_hit_count_per_sec: "key hit count",
  key_miss_count_per_sec: "key miss count",
  key_mutation_count_per_sec: "key mutation count",
  // Debug Mode: Slab Stabs
  // TODO need to revisit slab stat aggregate type
  items_64: "64B",
  bytes_64: "64B",
  eviction_rate_64: "64B",
  eviction_unexpired_rate_64: "64B",
  outofmemory_64: "64B",
  items_128: "128B",
  bytes_128: "128B",
  eviction_rate_128: "128B",
  eviction_unexpired_rate_128: "128B",
  outofmemory_128: "128B",
  items_256: "256B",
  bytes_256: "256B",
  eviction_rate_256: "256B",
  eviction_unexpired_rate_256: "256B",
  outofmemory_256: "256B",
  items_512: "512B",
  bytes_512: "512B",
  eviction_rate_512: "512B",
  eviction_unexpired_rate_512: "512B",
  outofmemory_512: "512B",
  items_1024: "1,024B",
  bytes_1024: "1,024B",
  eviction_rate_1024: "1,024B",
  eviction_unexpired_rate_1024: "1,024B",
  outofmemory_1024: "1,024B",
  items_2048: "2,048B",
  bytes_2048: "2,048B",
  eviction_rate_2048: "2,048B",
  eviction_unexpired_rate_2048: "2,048B",
  outofmemory_2048: "2,048B",
  items_4096: "4,096B",
  bytes_4096: "4,096B",
  eviction_rate_4096: "4,096B",
  eviction_unexpired_rate_4096: "4,096B",
  outofmemory_4096: "4,096B",
  items_8129: "8,129B",
  bytes_8129: "8,129B",
  eviction_rate_8129: "8,129B",
  eviction_unexpired_rate_8129: "8,129B",
  outofmemory_8129: "8,129B",
  items_16384: "16,384B",
  bytes_16384: "16,384B",
  eviction_rate_16384: "16,384B",
  eviction_unexpired_rate_16384: "16,384B",
  outofmemory_16384: "16,384B",
  items_32768: "32,768B",
  bytes_32768: "32,768B",
  eviction_rate_32768: "32,768B",
  eviction_unexpired_rate_32768: "32,768B",
  outofmemory_32768: "32,768B",
  items_65536: "65,536B",
  bytes_65536: "65,536B",
  eviction_rate_65536: "65,536B",
  eviction_unexpired_rate_65536: "65,536B",
  outofmemory_65536: "65,536B",
  items_131072: "131,072B",
  bytes_131072: "131,072B",
  eviction_rate_131072: "131,072B",
  eviction_unexpired_rate_131072: "131,072B",
  outofmemory_131072: "131,072B",
  items_262144: "262,144B",
  bytes_262144: "262,144B",
  eviction_rate_262144: "262,144B",
  eviction_unexpired_rate_262144: "262,144B",
  outofmemory_262144: "262,144B",
  items_524288: "524,288B",
  bytes_524288: "524,288B",
  eviction_rate_524288: "524,288B",
  eviction_unexpired_rate_524288: "524,288B",
  outofmemory_524288: "524,288B",
  items_1048576: "1,048,576B",
  bytes_1048576: "1,048,576B",
  eviction_rate_1048576: "1,048,576B",
  eviction_unexpired_rate_1048576: "1,048,576B",
  outofmemory_1048576: "1,048,576B",
  // Watcher stats
  skipped: "skipped",
  drift: "drift",
  restarts: "restarts",
  dropped: "dropped",
  processed: "processed",
  skipped_fraction: "skipped fraction",
  dropped_fraction: "dropped fraction",
  processed_fraction: "processed fraction",
  // Raw InfluxDB query stats
  idle: "idle",
  user: "user",
  system: "system",
  total: "total",
  free: "free",
  softirq: "softirq",
  steal: "steal",
  nice: "nice",
  irq: "irq",
  iowait: "iowait",
  guest: "guest",
  guest_nice: "guest_nice",
};

// Processed stats to be included in the compound metrics series
// added in modules/debug-mode
export const COMPOUND_METRICS_PROCESSED_STATS = ["items", "bytes", "hit_rate"];

// Custom stats created by calculating a prefix stats value as a %
// of a corresponding compound stats.
// calculated in utils/debug-mode
export const PREFIX_COMPOUND_METRIC_PREFIX = "prefix_over_compound_";
export const PREFIX_COMPOUND_METRICS = [
  PREFIX_COMPOUND_METRIC_PREFIX + "num_keys",
  PREFIX_COMPOUND_METRIC_PREFIX + "total_size",
  PREFIX_COMPOUND_METRIC_PREFIX + "total_hits_rate",
  PREFIX_COMPOUND_METRIC_PREFIX + "total_misses_rate",
  PREFIX_COMPOUND_METRIC_PREFIX + "total_mutations_rate",
  PREFIX_COMPOUND_METRIC_PREFIX + "requests",
] as const;

export const KEY_METRICS = [
  "time",
  "key_name",
  "key_size",
  "key_hit_count",
  "key_miss_count",
  "key_mutation_count",
  // calculated in modules/debug-mode
  "key_hit_rate",
  "key_hit_count_per_sec",
  "key_miss_count_per_sec",
  "key_mutation_count_per_sec",
];

// Used instead of the `prefix_hit_rate` stat label `prefix hit rate`
// because the `prefix_` is not desired
export const PREFIX_HIT_RATE_LABEL = "hit rate"; // corresponding CSS width $label-hitrate-width

export const HELP_PREFIX_FRACTION_REQUESTS = "% of recent requests";
export const HELP_PREFIX_FRACTION_ITEMS = "% of recently active items";
export const HELP_PREFIX_FRACTION_MEMORY = "% of recently active memory";

// Subtract 1s, 1000ms, to allow margin to refetch more consistently.
// Otherwise time comparison will fluctuate by a tiny amount, occasionally preventing
// refetching when data was only valid for another few ms.
export const LIFETIME_MARGIN = 1000; // 1s in ms

// Duration for which data is valid (up to date)
export const COMPOUND_STATS_LIFETIME = 1000 * 60 * 10; // 10 mins in ms
export const PREFIX_STATS_LIFETIME = 1000 * 60 * 10; // 10 mins in ms
export const POPULAR_ITEMS_LIFETIME = 1000 * 60 * 10; // 10 mins in ms
export const PREFIX_POPULAR_ITEMS_LIFETIME = 1000 * 60 * 10; // 10 mins in ms
export const PROCESSED_STATS_LIFETIME = 1000 * 60 * 10; // 10 mins in ms
export const STATS_LIFETIME = 1000 * 60 * 10; // 10 mins in ms

// For creating a fresh empty series array, without reference
export function emptySeriesArray(): Series[] {
  return [
    {
      columns: [],
      name: "",
      values: [],
    },
  ];
}

// The max number of prefixes that can be created on the highest MemCachier plan.
// For Analytics only. Eventually will probably make sense to be sent from the backend.
export const PREFIX_MAX = 100;
